<template>
  <oie-my-pages-template :title="t('addNewCustomerTitle')" :text="t('addNewCustomerSubTitle')" :with-go-back="true">
    <oie-add-edit-machine-owner-form @cancel="goBack" @save="goBack"></oie-add-edit-machine-owner-form>
  </oie-my-pages-template>
</template>

<script>
import myPages from '@/mixins/my-pages'

export default {
  mixins: [myPages]
}
</script>
